<template>
  <div>
    <Header :home="false" :logged="true" :arealogada="true"/>

    <div id="painel" class="container-fluid">
      <div id="wrapper-spinner" v-if="loading">
        <BeatLoader color="var(--main-azul)" />
      </div>
      <b-row>
        <b-col cols="12" md="4" lg="3" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex h-100 w-100 justify-content-center">
          <div class="row">
            <div class="col-8" v-if="data.boleto.endereco != null && data.boleto.config == 29">
              <br>
              <h5>Seu boleto está disponível para pagamento, clique no botão abaixo para visualizar!</h5>
              <br>
              <a class="btn btn-primary" style="display:block" :href="data.boleto.endereco" > Baixar boleto </a>
            </div>
            <div class="col-8" v-if="data.boleto.endereco == null">
            <div class="row">
              <div class="col-12">
                <b-form-select id="input-4" v-model="formaPagamento" :options="formasPagamento" @change="alteraFPG"></b-form-select>
                <p class="mt-3">Caso o pagamento não seja realizado na data de vencimento, o pedido será automaticamento cancelado.</p>
                  <br>
                  <p>A opção de pagamento de certidão/cancelamento, seja por meio de PIX, cartão de crédito ou boleto não altera o prazo de entrega/efetivação, pois a transferência ao devido tabelionato, ocorre 1 dia após ao efetivo pagamento.</p>
                  <br>
                  <p><b style="color: red;">*Após realizado o pagamento, os pedidos não poderão mais ser cancelados</b></p>
                  <br>
                  <p>O processamento dos pagamentos são realizados pela Parcela Express Servicos Digitais.</p>
                <div v-if="formaPagamento.toString().includes('credit') == true" class="mt-4">
                  <b-card bg-variant="light" title="Dados do cartão">
                     <parcela-checkout 
                      :environment=ENVIRONMENT_EXPRESS
                      :clientKey=CLIENT_KEY_EXPRESS
                      :apiUrl=URL_EXPRESS
                      :sellerKey=SELLER_KEY_EXPRESS
                      successReturnUrl="https://success-url.com.br"
                      errorReturnUrl="https://error-url.com.br"
                    />
                  </b-card>
                  <br>
                </div>
              </div>
              <div class="col-12">
                <b-button size="lg" variant="success" @click="respConfirm('s')"  v-if="formaPagamento.toString().includes('credit') !== true && formaPagamento != 0">Continuar</b-button>
              </div>
            </div>
          </div>
            <div v-if="data.boleto.endereco != null && data.boleto.config == 32" class="col-8">
              <div>
                <div class="col-12">
                  <h5>Pagamento por PIX</h5>
                  <p><b>Valor  {{ currencyFormatter.format(data.total) }}</b></p>
                </div>
                <div class="col-8 qrcodePix">
                    <b-embed type="iframe" aspect="1by1" :src="pdf" allowfullscreen v-if="pdf"></b-embed>
                </div>
                <div class="col-12">
                    <h5><b>Faça a leitura do QR CODE e aguarde.</b></h5>
                    <h5><b>Ou</b></h5>
                    <b-card>
                      <h5><b>LINK DE PAGAMENTO (PIX COPIA E COLA)</b></h5>
                      <textarea class="textarea" ref="copiar" v-model="data.boleto.endereco" cols="80" rows="4">
                      </textarea>
                       <b-button variant="primary" @click="copiarLink()">
                        <font-awesome-icon icon="copy" /> &nbsp;&nbsp;&nbsp;&nbsp; Copiar link de pagamento
                    </b-button>
                    </b-card>
                    <h4><b><br><br>Consulta de pagamento em {{secondcd}} segundos.</b></h4>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="row">
                <div class="col-12">
                  <h4> Resumo do pedido</h4>
                </div>
                <div class="col-12">
                  <div class="card mb-3 p-2" v-for="d in data.items">
                    <h6>{{d.cartorio}}</h6>
                    <p><b>{{ d.produto }}</b></p>
                    <p> Subtotal: {{ currencyFormatter.format(d.vl_orcamento) }}</p>
                  </div>
                  <div class="card mb-3 p-2" style="background: #EFEFEF;">
                    <p><b>Total:</b> {{ currencyFormatter.format(data.total) }}</p>
                    <p><b>Itens:</b> {{ data.total_items }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-modal ref="modalLoading" size="xl" title="Carregando" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
        <p class="my-4">
          <template>
            <div class="d-flex justify-content-center mb-3">
              <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
            </div>
          </template>
        </p>
      </b-modal>
      <b-modal ref="ModalPagamentoCartao" title="Pagamento Recusado">
        <p>Pagamento recusado! Verifique os dados do cartão e tente novamente.</p>
      </b-modal>
    </div>
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import Header from '../components/Header'
import Estados from '../services/estados'
import API from '../services/api'
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";
import axios from "axios"
import Menu from '../template/Menu'
import '@parcelaexpress/checkout-component-js';

export default {
  components: {
    Header,
    BeatLoader,
    footersite,
    footersitemobile,
    Menu,
  },
  data() {
    return {
      logged: true,
      loading: true,
      data: {
        boleto: {
          endereco: null,
          config: null,
        }
      },
      parcelas: [],
      pdf: null,
      sizemodalboleto: null,
      mensagemBolErro: "",
      linkPIX: null,
      currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),
      CLIENT_KEY_EXPRESS: process.env.VUE_APP_CLIENT_KEY_EXPRESS,
      SELLER_KEY_EXPRESS: process.env.VUE_APP_SELLER_KEY_EXPRESS,
      URL_EXPRESS:process.env.VUE_APP_URL_EXPRESS,
      ENVIRONMENT_EXPRESS: process.env.VUE_APP_ENVIRONMENT_EXPRESS,
      formaPagamento: 0,
      boletoSelecionado: {},
      formasPagamentoExpress: [],
      formasPagamento:[
        { text: 'Selecione uma opção de pagamento', value: 0 },
        { text: 'BOLETO - Parcela Express ( Tarifa Bancária - R$ 0,87 )', value: 2 },
        { text: 'PIX - Parcela Express ( Gratuito )', value: 3 },
      ],
    }
  },
  methods: {
    init(key) {
        var token = localStorage.getItem('jwtToken');
        API.get(`carrinho/checkout/${key}?token=${token}`).then((res) => {
          this.data = res.data;
          this.simulacaoPagamentos(res.data.total)
          if(res.data.boleto.config == 32) {
            var Quickchart = 'https://quickchart.io/qr?size=300&text=';
            this.pdf = Quickchart + encodeURI(res.data.boleto.endereco);
            // GoogleCharts QR Code - DEPRECATED
            // var GoogleCharts = 'https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=';
            // this.pdf = GoogleCharts + res.data.boleto.endereco;
          }
          this.loading = false;
        })
    },
    copiarLink(){
        var copyTextarea = this.$refs.copiar
        
        copyTextarea.select();

        try {
          var successful = document.execCommand('copy');
          this.$toasted.show('Texto copiado!')
        } catch (err) {
          this.$toasted.show('Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.')
        }
      
    },
    formataReais(number){
      number = parseFloat((number/100)).toFixed(2);
      return new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL', minimumFractionDigits: 2}).format(number);
    },
    async simulacaoPagamentos(vlr_simulacao){
      let valor_simulado = parseFloat(vlr_simulacao).toFixed(2).replace('.','') / 1
      let resSimulacao = await axios.get(`${process.env.VUE_APP_URL_EXPRESS}/v1/simulation/sellers/${process.env.VUE_APP_SELLER_KEY_EXPRESS}?amount_cents=${valor_simulado}`);
      let formasPagamentoSimulacao = resSimulacao.data.filter( d => d.type == 'credit')
      let self = this
      this.formasPagamentoExpress = formasPagamentoSimulacao
      formasPagamentoSimulacao.forEach( (value) => {
        self.formasPagamento.push({html: '<b> Cartão de Crédito - Parcela Express  ' + value.installment  + ' x ' + this.formataReais(value.installment_amount_cents) +'</b> ( Tarifa Bancária - ' + value.cet + '% )', 'value': value.code })
      })
    },
    respConfirm(resp){
      if (resp == "s") {
        const token = localStorage.getItem('jwtToken')
        const dadosParaEnvio = { filtro: {cart: this.data.key, vl_orcServ: this.data.total}, formaPagamento: this.formaPagamento };
        this.$refs['modalLoading'].show();

        API.post(`certidao/gerarBoleto`, { token: token, dados: dadosParaEnvio }).then((res) => {
          console.log(res);
          if (res.data.situacao == 1) {
            if(this.formaPagamento == 2)
            {
              this.$refs['modalLoading'].hide();
              this.data.boleto.endereco = res.data.urlBoleto;
              this.data.boleto.cd_api_boleto_config = 29;
              this.$refs['modalPagamento'].hide();
            }
            else if(this.formaPagamento == 3)
            {
              this.data.boleto.endereco = res.data.urlBoleto;
              var Quickchart = 'https://quickchart.io/qr?size=300&text=';
              this.pdf = Quickchart + encodeURI(res.data.urlBoleto);
              // GoogleCharts QR Code - DEPRECATED
              // var GoogleCharts = 'https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=';
              // this.pdf = GoogleCharts + res.data.urlBoleto;
              this.data.boleto.cd_api_boleto_config = 32;

              this.sizemodalboleto = 'lg'
              let self = this                
              this.$refs['modalLoading'].hide();
              this.$refs['modalPagamento'].hide();
            }
          } else {
            this.mensagemBolErro = res.data.mensagem;
            this.$refs['modalLoading'].hide();
          }
        }).catch(erro => {
          console.log("post não enviado", erro);
        })
      }
      if (resp == "n")this.$refs['modalPagamento'].hide();

    },
    async alteraFPG(){
      this.percent_value = null
      // let valor_calculado = this.calcula_valor_pagamento();
      let self = this
      let retornoIP = await axios.get(`https://api.ipify.org/?format=json`)
      
      const token = localStorage.getItem('jwtToken')
      let costumerBillinAdrres =  await API.get(`usuario/logado/endereco?token=${token}`)
      costumerBillinAdrres = costumerBillinAdrres.data
      
     
      setTimeout(function () {
        const web_component = document.querySelector('parcela-checkout');
        let dadosFormaPagamento = self.formasPagamentoExpress.filter( d => d.code == self.formaPagamento)[0]
        let amount_cents = dadosFormaPagamento != undefined ? parseInt(dadosFormaPagamento.total_amount_cents) : '';
        // console.log(self.boletoSelecionado)

        if(self.formaPagamento.toString().includes("credit") == true)
        {
          //API.post(`cancelamento/gerarPedido`, self.boletoSelecionado).then( (res) => {

          
            web_component.customerData = {
             amount_cents: amount_cents,
             description: 'Pagamento do pedido',
             form_payment: "credit",
             installment_plan: {
               number_installments: dadosFormaPagamento.installment,
             },
             customer: {
               email: localStorage.getItem('usrEmail'),
               ip: retornoIP.data.ip,
               first_name: localStorage.getItem('usrName'),
               last_name: " ",
               document: localStorage.getItem('usrCpf'),
               billing_address: {
                 city: costumerBillinAdrres.cidade,
                 country: costumerBillinAdrres.pais,
                 house_number_or_name: costumerBillinAdrres.numero,
                 postal_code: costumerBillinAdrres.cep.replace('-',''),
                 state: costumerBillinAdrres.estado,
                 street: costumerBillinAdrres.rua,
               },
             },
             extract_identification:'IEPTB-BR',
             pre_capture: false,
             has_split_rules: false,
             confirmation_required: false,
           };

           console.log(web_component);
         
           web_component.onChange = () => 
             {
               // console.log(state);
             }
           
             web_component.beforeSubmit  = () => self.$refs['modalLoading'].show();
           
             web_component.onSubmit = (state) => {
               self.$refs['modalLoading'].show();
               if(state.resultCode == 'Refused' || state.resultCode == 'Unauthorized')
               {
                 self.$refs['modalLoading'].hide();
                 self.$refs['ModalPagamentoCartao'].show();
               }
               else self.atualizaPagamento(state.sale_id);
             };
        //})
        }
        },1)
    },
  },
  created() {
    this.init(this.$route.params.key);
  }
}

</script>

<style>
#wrapper-spinner {
  position: fixed;
  width: 96%;
  left: 0px;
  bottom: 0px;
  padding-top: 30px;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  background-color: #ffffff;
  overflow-x: hidden;
    border-top: 1px solid #f1f1f1;
}
</style>